import useTestId from '@ori/testid-generator';
import React, { type FC, Suspense } from 'react';

import { useFooter } from '../../hooks';
import { ContentRoot } from '../ContentRoot';
import { QRCodeSkeleton } from './components/styles';
import { MARKET_EXCEPTIONS, QR_SKELETON } from './constants';

const LazyTurkishMarketException = React.lazy(async () =>
  import('./components/TurkishMarketException').then((module) => ({ default: module.TurkishMarketException })),
);

export const MarketExceptions: FC = () => {
  const { getTestId } = useTestId();
  const { turkishException } = useFooter();

  return turkishException ? (
    <ContentRoot testId={getTestId(MARKET_EXCEPTIONS)}>
      <Suspense fallback={<QRCodeSkeleton data-testid={getTestId(QR_SKELETON)} />}>
        <LazyTurkishMarketException />
      </Suspense>
    </ContentRoot>
  ) : null;
};
